import PropTypes from 'prop-types'

import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

// The strip every question type lays its own controls out in, plus the one thing they all offer:
// opening or closing the items at once. What those items are called is the question type's word for
// them, so it is given rather than worked out here.
const ControlsWithToggle = ({
  children,
  type,
  itemsLabel = 'subquestions',
  batches,
  itemsCollapsed,
  onToggleBatches
}) => (
  <div data-test-id={`controls-with-toggle-${type}`} className={`${style.component} ${NO_PRINT}`}>
    {children}
    {batches?.length > 1 ? (
      <span
        className={`${style.toggle} p-right`}
        aria-expanded={!itemsCollapsed}
        {...pressable(() => onToggleBatches(!itemsCollapsed))}
      >
        {itemsCollapsed ? 'Expand' : 'Collapse'} {itemsLabel}
      </span>
    ) : null}
  </div>
)

ControlsWithToggle.propTypes = {
  children: PropTypes.any,
  type: PropTypes.string,
  itemsLabel: PropTypes.string,
  batches: PropTypes.array,
  itemsCollapsed: PropTypes.bool,
  onToggleBatches: PropTypes.func
}

ControlsWithToggle.displayName = 'ControlsWithToggle'

export default ControlsWithToggle
